<template>
  <div class="log">
    <b-container class="page-container">
      <b-row>
        <b-col md="1"></b-col>
        <h1 class="title" style="padding-left: 10px">Exurgo
          <small>Development Log</small>
        </h1>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-breadcrumb :items="items"/>
      </b-row>
      <hr>
      <h1 v-if="loading">
        <font-awesome-icon :icon="['fas', 'circle-notch']" class="fa-spin"/>
      </h1>
      <div v-if="currentEntries && !loading">
        <ul id="no-bullet">
          <li v-for="entry in currentEntries" :key="entry.entryId">
            <log-entry :entryId="entry.entryId" :title="entry.title" :summary="entry.summary" :graphic="entry.graphic" :displayDate="entry.displayDate" :createdBy="entry.createdBy"></log-entry>
            <hr>
          </li>
        </ul>
        <b-pagination :total-rows="entries.length" v-model="currentPage" :per-page="entriesOnPage" v-on:input="setCurrentEntries"  align="center">
        </b-pagination>
        <br>
      </div>
    </b-container>
  </div>
</template>

<script>
import LogEntry from '../components/LogEntry.vue'
import axios from 'axios'

export default {
  name: 'log',
  components: {
    LogEntry
  },
  data () {
    return {
      entries: [],
      items: [
        {text: 'Home', to: '/'},
        {text: 'Development Log', active: true}
      ],
      currentPage: 1,
      entriesOnPage: 4,
      currentEntries: [],
      loading: true

    }
  },
  methods: {
    getEntries: function () {
      axios.get('http://bargoapi.finitegames.com/api/finitegames/getallentries')
        .then((response) => {
          this.entries = response.data.Entries
          var i
          for (i = 0; i < this.entriesOnPage; i++) {
            this.currentEntries.push(this.entries[i])
          }
          this.loading = false
        }, (error) => {
          console.log(error)
          this.loading = false
        })
    },
    setCurrentEntries: function () {
      this.currentEntries.length = 0
      var startPageIndex = 0
      var endPageIndex = 0
      var i = 0
      startPageIndex = (this.currentPage - 1) * this.entriesOnPage
      endPageIndex = startPageIndex + this.entriesOnPage
      if (endPageIndex > this.entries.length) {
        endPageIndex = this.entries.length
      }
      for (i = startPageIndex; i < endPageIndex; i++) {
        this.currentEntries.push(this.entries[i])
      }
    }
  },
  beforeMount () {
    this.getEntries()
  }
}
</script>

<style scoped>
  ul#no-bullet {
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Log.vue